import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getWorkDashboard } from "../api/workApi";
import KpiCard from "../../../components/common/KpiCard";

const WorkDashboard = () => {
  const navigate = useNavigate();

  const [kpis, setKpis] = useState({
    activeEngagements: 0,
    overdueTasks: 0,
    dueThisWeek: 0,
    staffUtilization: 0
  });

  const [engagements, setEngagements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDashboard();
  }, []);

  const loadDashboard = async () => {
    try {
      const res = await getWorkDashboard();

      setKpis(res.data?.summary || {});
      setEngagements(res.data?.list || []);

    } catch (err) {
      console.error("Dashboard load failed", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="space-y-6">

      <h1 className="text-2xl font-semibold">
        Work Command Center
      </h1>

      {/* KPI STRIP */}
      <div className="grid md:grid-cols-4 gap-4">
        <KpiCard label="Active Engagements" value={kpis.activeEngagements || 0} />
        <KpiCard label="Overdue Tasks" value={kpis.overdueTasks || 0} />
        <KpiCard label="Due This Week" value={kpis.dueThisWeek || 0} />
        <KpiCard
          label="Staff Utilization"
          value={`${kpis.staffUtilization || 0}%`}
        />
      </div>

      {/* EXECUTION BOARD */}
      <div className="bg-white p-5 rounded-xl shadow">
        <h3 className="font-semibold mb-4">
          Engagement Execution
        </h3>

        {engagements.length === 0 && (
          <div className="text-slate-500 text-sm">
            No active engagements found.
          </div>
        )}

        {engagements.map((e) => {
          const progress =
            e.totalChecklist > 0
              ? Math.round((e.approvedChecklist / e.totalChecklist) * 100)
              : 0;

          return (
            <div
              key={e.workId}
              onClick={() => navigate(`/tasks/work/${e.workID}`)}
              className="mb-4 cursor-pointer hover:bg-slate-50 p-3 rounded transition"
            >
              <div className="flex justify-between text-sm font-semibold">
                <span>{e.clientName}</span>
                <span
                  className={
                    e.status === "Delayed"
                      ? "text-red-600"
                      : "text-indigo-600"
                  }
                >
                  {e.status}
                </span>
              </div>

              <div className="text-xs text-slate-500">
                {e.assignmentType}
              </div>

              <div className="w-full bg-slate-200 h-2 rounded mt-2">
                <div
                  className={`h-2 rounded ${
                    e.status === "Delayed"
                      ? "bg-red-500"
                      : "bg-indigo-600"
                  }`}
                  style={{ width: `${progress}%` }}
                />
              </div>

              <div className="text-xs text-right mt-1 text-slate-500">
                {progress}% Complete
              </div>
            </div>
          );
        })}
      </div>

    </div>
  );
};

export default WorkDashboard;